import type { UiIconName } from './components/ui-icon';

export interface AdminWorkspaceAccess {
  readonly hasPermission: (permission: string) => boolean;
  readonly managedMembership: boolean;
  readonly canManageIdentity: boolean;
}

export interface AdminWorkspaceAction {
  readonly to: string;
  readonly titleKey: string;
  readonly bodyKey: string;
  readonly icon: UiIconName;
}

/** The overview and navigation share the same effective permission contract. */
export function adminWorkspaceActions(access: AdminWorkspaceAccess): ReadonlyArray<AdminWorkspaceAction> {
  const { hasPermission, managedMembership, canManageIdentity } = access;
  const actions: AdminWorkspaceAction[] = [];
  if (hasPermission('events:read')) actions.push({
    to: '/admin/events', titleKey: 'nav.events', bodyKey: 'admin.workspace.events', icon: 'calendar',
  });
  if (hasPermission('events:write')) actions.push({
    to: '/admin/event-types', titleKey: 'eventTypes.title', bodyKey: 'admin.workspace.eventTypes', icon: 'flow',
  });
  if (managedMembership ? hasPermission('identity:read') : canManageIdentity) actions.push({
    to: managedMembership ? '/admin/organization' : '/admin/identity',
    titleKey: managedMembership ? 'organization.members' : 'nav.identity',
    bodyKey: managedMembership ? 'admin.workspace.members' : 'admin.workspace.identity', icon: 'shield',
  });
  if (hasPermission('reporting:read')) actions.push({
    to: '/admin/reporting', titleKey: 'nav.reporting', bodyKey: 'admin.workspace.reporting', icon: 'report',
  });
  if (hasPermission('privacy:read')) actions.push({
    to: '/admin/organization/privacy', titleKey: 'privacy.title', bodyKey: 'admin.workspace.privacy', icon: 'shield',
  });
  if (hasPermission('branding:manage')) actions.push({
    to: '/admin/organization/branding', titleKey: 'branding.title', bodyKey: 'admin.workspace.branding', icon: 'spark',
  });
  if (hasPermission('attendance:scan')) actions.push({
    to: '/admin/scanner', titleKey: 'nav.scanner', bodyKey: 'admin.workspace.scanner', icon: 'scanner',
  });
  if (hasPermission('tasks:review')) actions.push({
    to: '/admin/reviews', titleKey: 'nav.reviewQueue', bodyKey: 'admin.workspace.reviews', icon: 'check',
  });
  if (hasPermission('notifications:manage')) actions.push({
    to: '/admin/notifications', titleKey: 'nav.notifications', bodyKey: 'admin.workspace.notifications', icon: 'status',
  });
  return actions;
}
